<template>
  <aw-drag
    :enable="edit"
    :drag-item="element"
    #default="{ dragHandle }"
    class="DocumentBlock -table bg-white"
    :class="{
      DocumentHasPlaceholder: element.placeholder,
      isCommentOpened: isCommentOpened,
      DocumentHighlightSearch: $route.hash === '#el' + element.id
    }"
    :id="'el' + element.id"
  >
    <div class="DocumentElement -table">
      <div
        class="w-full bg-bc-blue flex flex-row justify-center space-x-2 p-4"
        v-if="element.locked && !isEveryElementLocked && !isPageLocked"
      >
        <aw-icon icon="lock" class="w-5 h-5 text-white " />
        <span class="text-white text-sm">Element is locked</span>
      </div>

      <div class="TableResponsiveWrapper">
        <table class="Table">
          <tr>
            <th
              class="py-2 px-3"
              :class="columnsAligning[index]"
              v-for="(th, index) in data.headers"
              :key="index"
            >
              <contenteditable
                tag="span"
                v-model="data.headers[index]"
                :contenteditable="edit"
                :noNL="true"
                :noHTML="true"
                :alwaysSelectAll="$t('Header')"
                @updated="updated = 'headers'"
              />
              <span
                v-if="edit"
                @click="deleteColumn(index)"
                class="cursor-pointer text-lg"
                >x</span
              >
            </th>
            <th v-if="edit"><!-- delete--></th>
            <th
              v-if="edit"
              class="py-2 px-0 !align-middle text-center w-8 !border-0 !border-l border-gray-400 border-dashed !bg-white relative"
              :rowspan="totalRows"
            >
              <document-add-table-col
                :parent="element"
                :page="page"
                :index="children.length"
                v-if="edit"
              />
            </th>
          </tr>
          <document-element-table-row
            v-for="(row, index) in children"
            :key="children[index].key"
            :element="children[index]"
            :parent="element"
            :page="page"
            :first-row="index === 0"
            @on-delete-row="deleteRow(index)"
            :aligning="columnsAligning"
            :class="{ DocumentElementDragged: row.dragged }"
          />

          <tr v-if="edit">
            <!-- +2 = delete column  -->
            <td :colspan="totalColumns + 1" class="py-2 px-3">
              <document-add-table-row
                :parent="element"
                :page="page"
                :index="children.length"
                v-if="edit"
              />
            </td>
          </tr>
        </table>
      </div>

      <!-- {* editacni akce *} -->
      <div class="DocumentBlock__PanelLeft -table"></div>

      <!-- comments -->
      <document-comment
        v-if="bcDocumentStore.document.allow_comments"
        v-model="element.comments"
        :element="element"
        :document="bcDocumentStore.document"
        @comment-toggle="resolveZindexOnParent"
      />

      <!-- panel s moznosti noveho elementu -->
      <document-hot-action
        :parent="parent"
        :page="page"
        :index="index + 1"
        v-if="edit && !isLastOnPage"
      />
    </div>
    <div class="DocumentBlock__PanelRight -table">
      <span
        ref="DocumentCircle"
        class="DocumentCircle mr-2.5 sm:mr-3.5"
        :class="{
          'DocumentCircle--active': bcSelectedStore.selected.has(element.id)
        }"
        :data-item-index="element.root_rank"
        @click.prevent.stop="bcSelectedStore.select(
          element, 
          {
            isRecursive: true,
            isShift: $event.shiftKey,
            isDocument: true,
            itemIndex: element.root_rank,
          }
        )"
      ></span>
      <span
        class="cursor-move text-gray-400 hover:text-gray-500"
        v-if="edit"
        :ref="dragHandle"
      >
        <aw-icon icon="dots" class="w-4 h-4 -mx-1 "></aw-icon>
        <aw-icon icon="dots" class="w-4 h-4 -mx-1 "></aw-icon>
      </span>
    </div>
  </aw-drag>
</template>

<script>
import BaseElement from '../../mixins/BaseElement'
import Selected from '../../mixins/Selected'

export default {
  mixins: [
    BaseElement,
    Selected,
  ],
  allowedChildElements: ['table-row'],
  methods: {
    deleteColumn(index) {
      // header
      this.data.headers.splice(index, 1)
      this.metaData = { deleteColIndex: index }
      // col
      this.children.forEach((row) => row.data.cols.splice(index, 1))
      // save
      this.updated = 'headers'
    },
    isNumber(value) {
      if (typeof value === 'string') {
        value = value.replace(/,/g, '')
      }

      return !isNaN(parseFloat(value)) && isFinite(value)
    }
  },
  computed: {
    totalColumns() {
      return this.children.length ? this.children[0].data.cols.length : 0
    },
    totalRows() {
      return this.children.length + 1 // +1 = th
    },
    columnsAligning() {
      const alignMapTable = []
      this.children.forEach((element) => {
        element.data.cols.forEach((column, index) => {
          if (!alignMapTable[index]) {
            alignMapTable[index] = this.isNumber(column)
              ? 'text-right'
              : 'text-center'
          } else if (
            alignMapTable[index] === 'text-right' &&
            !this.isNumber(column)
          ) {
            alignMapTable[index] = 'text-center'
          }
        })
      })
      return alignMapTable
    }
  },
  mounted() {
    this.assignItemToSelectBtn('DocumentCircle', this.element)
  },
}
</script>

<style lang="scss" scoped></style>
